import request from '../utils/request'
import QS from "qs";

export function getRecordList (data) {
  return request({
    url: '/api/user/wallet/recharge-record',
    method: 'get',
    params:data,
  })
}
export function rechargeMoney (data) {
  return request({
    url: '/api/user/wallet/recharge',
    method: 'post',
    params: data
  })
}

export function orderPayMoney (id,type,data) {
  return request({
    url: `/api/payment/${id}/${type}`,
    method: 'post',
    params:data,
  })
}
export function walletAccount (data) { // 开户
  return request({
    url: '/api/user/wallet/account',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function getPlugRandomKey () { // 获取密码控件plugRandomKey(随机数)
  return request({
    url: '/api/user/wallet/plug-randomkey',
    method: 'get',
  })
}
export function sendSms (data) { //发送验证码
  return request({
    url: '/api/user/wallet/send-sms',
    method: 'get',
    params:data,
  })
}
export function getWalletBank () { // 银行卡-列表
  return request({
    url: '/api/user/wallet/bank',
    method: 'get',
  })
}
// /api/user/wallet/bind-card
export function bindCard (data) { //绑定银行卡
  return request({
    url: '/api/user/wallet/bind-card',
    method: 'post',
    data:QS.stringify(data),
  })
}

export function setDefault (id) { //设置默认
  return request({
    url: `/api/user/wallet/${id}/set-default`,
    method: 'put',
  })
}
// /api/user/wallet/{id}/remove
export function setRemove (id) { // 删除
  return request({
    url: `/api/user/wallet/${id}/remove`,
    method: 'delete',
  })
}

export function walletPush (id,data) { //提现
  return request({
    url: `/api/user/wallet/${id}/push`,
    method: 'post',
    data:QS.stringify(data),
  })
}
export function walletPushTransfer (data) { //查询上一次未成功的提现记录
  return request({
    url: '/api/user/wallet/last-transfer',
    method: 'get',
    params:data,
  })
}
export function walletPushOld (id,data) { //重新发起上次提现
  return request({
    url: `/api/user/wallet/${id}/old-push`,
    method: 'put',
    data:QS.stringify(data),
  })
}
export function walletBalance (data) { //查询余额
  return request({
    url: '/api/user/wallet/balance',
    method: 'get',
    params:data,
  })
}
export function walletBalanceTest (data) { //test查询余额
  return request({
    url: '/api/wallet/balance',
    method: 'get',
    params:data,
  })
}
 // /api/poly/register
export function registerCode (data) { //聚合码注册
  return request({
    url: 'api/poly/register',
    method: 'post',
    data:QS.stringify(data),
  })
}
